<template>
  <button
    type="button"
    class="control-tab"
    :class="{ 'is-active': isActive }"
    @click="changeTab"
  >
    <span>{{ tabName }}</span>
  </button>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    tabLink: {
      type: String,
      default: '',
    },
    tabName: {
      type: String,
      default: '',
    },
  },
  methods: {
    changeTab() {
      this.$emit('change-tab', this.tabLink);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/variables';

.control-tab {
  font-size: 14px;
  color: $black-j;
  padding: 5px 3px;
  background: transparent;
  outline: none;
  border-bottom: 2px solid transparent;
  display: inline-block;

  &:hover {
    opacity: 0.3;
    color: #bec0c2;
  }

  &.is-active {
    color: $blue;
    border-bottom: 2px solid $blue;

    &:hover {
      opacity: 1;
      cursor: initial;
    }
  }
}
</style>
